// WebWorker.js
module.exports = function WebWorker(worker){    
  let code = worker.toString();
  code = code.substring(code.indexOf("{") + 1, code.length);

  if(code.indexOf('return ') === 0){
    code = "var onmessage = " + code.substring(6, code.lastIndexOf('}'));
  } else {
    code = code.substring(0, code.lastIndexOf('return onmessage'));
  }
  
  const blob = new Blob([code], { type: "application/javascript" });
  return new Worker(URL.createObjectURL(blob));
}


// WEBPACK FOOTER //
// ./src/pattern_utilities/WebWorker.js